var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Title = styled.h4(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: 0;\n"], ["\n  margin-top: ", ";\n  margin-bottom: 0;\n"])), function (_a) {
    var marginTop = _a.marginTop;
    return marginTop || '0px';
});
export var NoAttachmentsWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
export var AllAttachmentsWrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--p-color-red-800);\n  gap: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--p-color-red-800);\n  gap: 10px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
